module.exports = __webpack_public_path__ + "images/assets/70fefb5db3fbf28864e6d68032a4b836.svg";